import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Menu, X, Heart } from 'lucide-react'
import './Navbar.css'

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/our-work', label: 'Our Work' },
  { to: '/raise-fund', label: 'Raise Fund' },
  { to: '/contact', label: 'Contact Us' },
  { to: '/newsroom', label: 'News Room' },
  { to: '/DonorsDen', label: 'Donners Den' },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [indicatorStyle, setIndicatorStyle] = useState({})
  const navRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (!navRef.current) return
    const active = navRef.current.querySelector('a.nav-active')
    if (active) {
      const navRect = navRef.current.getBoundingClientRect()
      const rect = active.getBoundingClientRect()
      setIndicatorStyle({ left: rect.left - navRect.left, width: rect.width, opacity: 1 })
    }
  }, [location.pathname])

  // Close menu on route change
  useEffect(() => { setOpen(false) }, [location.pathname])

  // Lock body scroll when menu open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [open])

  return (
    <>
      <header className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
        <div className="navbar__inner">
          <NavLink to="/" className="navbar__logo" onClick={() => setOpen(false)}>
            <div className="navbar__logo-icon"><span>MSS</span></div>
            <div className="navbar__logo-text">
              <span className="navbar__logo-name">Malyabanta</span>
              <span className="navbar__logo-sub">Swechhasevi Samiti</span>
            </div>
          </NavLink>

          <nav className="navbar__links" ref={navRef}>
            <div className="navbar__indicator" style={indicatorStyle} />
            {navLinks.map(link => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === '/'}
                className={({ isActive }) => `navbar__link${isActive ? ' nav-active' : ''}`}
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <NavLink to="/donate" className="navbar__cta btn btn-primary" onClick={() => setOpen(false)}>
            <Heart size={16} /> Donate Now
          </NavLink>

          <button className="navbar__hamburger" onClick={() => setOpen(o => !o)} aria-label="Toggle menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile menu rendered OUTSIDE <header> to escape stacking context */}
      {open && (
        <div className="navbar__mobile-overlay" onClick={() => setOpen(false)}>
          <div className="navbar__mobile-panel" onClick={e => e.stopPropagation()}>
            <div className="navbar__mobile-links">
              {navLinks.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === '/'}
                  className={({ isActive }) => `navbar__mobile-link${isActive ? ' nav-active' : ''}`}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </NavLink>
              ))}
              <NavLink to="/donate" className="btn btn-primary navbar__mobile-cta" onClick={() => setOpen(false)}>
                <Heart size={16} /> Donate Now
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </>
  )
}